import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(),
    textDecoration: 'underline'
  }
}))
